import { DropdownMultiSelect } from './DynamicDropdownMultiSelect'
import { DiagnosesDropdownSelect } from './DiagnosesDropdownSelect'
import { SummaryInput } from './SummaryInput'
import { QuestionColumnRadioSelect } from './ColumnRadioSelect'
import { DateInput } from './DateInput'

export const dynamicInputComponentMapper = {
  SummaryInput: SummaryInput,
  QuestionColumnRadioSelect: QuestionColumnRadioSelect,
  DiagnosesSelect: DiagnosesDropdownSelect,
  MultiSelectDropdown: DropdownMultiSelect,
  DateInput: DateInput
}

// Layout constants
export const COLUMN_GAP = '20px'
